/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_Creations_Yearlytitle1Inputs */

const id_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreasi tahunan`)
};

const ms_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciptaan tahunan`)
};

const da_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årlige oprettelser`)
};

const de_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jährliche Kreationen`)
};

const en_us2_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yearly creations`)
};

const es_es2_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creaciones anuales`)
};

const es_mx2_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creaciones anuales`)
};

const fil_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taunang creation`)
};

const fr_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créations annuelles`)
};

const it_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creazioni annuali`)
};

const hu_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éves létrehozások`)
};

const nl_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaarlijkse creaties`)
};

const no_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årlige opprettelser`)
};

const pl_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twory roczne`)
};

const pt_br2_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criações anuais`)
};

const pt_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criações anuais`)
};

const ro_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creații anuale`)
};

const fi_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuosittaiset luonnit`)
};

const sv_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årliga skapelser`)
};

const vi_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sáng tạo hàng năm`)
};

const tr_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yıllık oluşturmalar`)
};

const cs_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roční vytvoření`)
};

const bg_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Годишни създавания`)
};

const ru_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежегодные предложения`)
};

const uk_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щорічні створення`)
};

const ar_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإنشاءات السنوية`)
};

const hi_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वार्षिक निर्माण`)
};

const th_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การสร้างรายปี`)
};

const ja_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年別作成数`)
};

const zh_cn2_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每年创作`)
};

const zh_hant1_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每年創作`)
};

const ko_stats_creations_yearlytitle1 = /** @type {(inputs: Stats_Creations_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연별 생성`)
};

/**
* | output |
* | --- |
* | "Yearly creations" |
*
* @param {Stats_Creations_Yearlytitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const stats_creations_yearlytitle1 = /** @type {((inputs?: Stats_Creations_Yearlytitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_Creations_Yearlytitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_stats_creations_yearlytitle1(inputs)
	if (locale === "ms") return ms_stats_creations_yearlytitle1(inputs)
	if (locale === "da") return da_stats_creations_yearlytitle1(inputs)
	if (locale === "de") return de_stats_creations_yearlytitle1(inputs)
	if (locale === "en-US") return en_us2_stats_creations_yearlytitle1(inputs)
	if (locale === "es-ES") return es_es2_stats_creations_yearlytitle1(inputs)
	if (locale === "es-MX") return es_mx2_stats_creations_yearlytitle1(inputs)
	if (locale === "fil") return fil_stats_creations_yearlytitle1(inputs)
	if (locale === "fr") return fr_stats_creations_yearlytitle1(inputs)
	if (locale === "it") return it_stats_creations_yearlytitle1(inputs)
	if (locale === "hu") return hu_stats_creations_yearlytitle1(inputs)
	if (locale === "nl") return nl_stats_creations_yearlytitle1(inputs)
	if (locale === "no") return no_stats_creations_yearlytitle1(inputs)
	if (locale === "pl") return pl_stats_creations_yearlytitle1(inputs)
	if (locale === "pt-BR") return pt_br2_stats_creations_yearlytitle1(inputs)
	if (locale === "pt") return pt_stats_creations_yearlytitle1(inputs)
	if (locale === "ro") return ro_stats_creations_yearlytitle1(inputs)
	if (locale === "fi") return fi_stats_creations_yearlytitle1(inputs)
	if (locale === "sv") return sv_stats_creations_yearlytitle1(inputs)
	if (locale === "vi") return vi_stats_creations_yearlytitle1(inputs)
	if (locale === "tr") return tr_stats_creations_yearlytitle1(inputs)
	if (locale === "cs") return cs_stats_creations_yearlytitle1(inputs)
	if (locale === "bg") return bg_stats_creations_yearlytitle1(inputs)
	if (locale === "ru") return ru_stats_creations_yearlytitle1(inputs)
	if (locale === "uk") return uk_stats_creations_yearlytitle1(inputs)
	if (locale === "ar") return ar_stats_creations_yearlytitle1(inputs)
	if (locale === "hi") return hi_stats_creations_yearlytitle1(inputs)
	if (locale === "th") return th_stats_creations_yearlytitle1(inputs)
	if (locale === "ja") return ja_stats_creations_yearlytitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_stats_creations_yearlytitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_stats_creations_yearlytitle1(inputs)
	return ko_stats_creations_yearlytitle1(inputs)
});
export { stats_creations_yearlytitle1 as "stats.creations.yearlyTitle" }